import { AmountInfo } from '@/components/dashboard/amount-info';
import { NewsBriefing } from '@/components/dashboard/news-briefing';
import { OrderSituation } from '@/components/dashboard/order-situation';
import { ReviewInquiryStatus } from '@/components/dashboard/review-inquiry';

import { BlogPreview } from '@/components/dashboard/blog-preview';
import { SellerboxAi } from '@/components/dashboard/sellerbox-ai';

import AlertDialog from '@/components/dashboard/alert-dialog';
import { TodaySummary } from '@/components/dashboard/today-summary.tsx';
import { NewsBriefingProvider } from './NewsBriefing/_context/NewsContext';

const HomePage = () => {
  return (
    <div className="scrollbar flex h-full w-full  flex-1 flex-col items-center gap-[16px] overflow-y-auto py-10">
      <AlertDialog />
      <div className="flex w-full flex-col items-center px-10  pb-10">
        <div className="w-full space-y-4">
          <div className="text-left text-gr-900 Title1S28">대시보드</div>
          <div className="flex w-full  max-w-[1560px] items-start gap-5">
            <div className="flex w-full flex-1 flex-col gap-5">
              {/* 오늘 요약 */}
              <TodaySummary />
              {/* 실시간 주문 현황 */}
              <OrderSituation />
              {/* 뉴스 브리핑 */}
              <NewsBriefingProvider>
                <NewsBriefing />
              </NewsBriefingProvider>
              {/* 블로그 */}
              <BlogPreview />
            </div>
            <div className="flex w-full flex-1 flex-col gap-5">
              {/* 신규 리뷰/문의 */}
              <ReviewInquiryStatus />
              {/* 매출 추이 */}
              <AmountInfo isDashboard />
              {/* Sellebox AI */}
              <SellerboxAi />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
